module.exports = __webpack_public_path__ + "static-portal/img/map-trq2.4c946ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-trq2.png
// module id = rP/x
// module chunks = 4